let _slideUp = (target, duration = 500, showmore = 0, widget=false) => {
	if (!target.classList.contains('_slide')) {
		target.classList.add('_slide');
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.height = `${target.offsetHeight}px`;
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = showmore ? `${showmore}px` : `0px`;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
        if(widget){
           window.scrollTo({
  								top: target.offsetTop,
  								behavior: "smooth",
  							});
        }
      
		window.setTimeout(() => {
			target.hidden = !showmore ? true : false;
			!showmore ? target.style.removeProperty('height') : null;
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			!showmore ? target.style.removeProperty('overflow') : null;
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			target.classList.remove('_slide');
             
			// Створюємо подію 
			document.dispatchEvent(new CustomEvent("slideUpDone", {
				detail: {
					target: target
				}
			}));
		}, duration);
	}
}
let _slideDown = (target, duration = 500, showmore = 0) => {
	if (!target.classList.contains('_slide')) {
		target.classList.add('_slide');
		target.hidden = target.hidden ? false : null;
		showmore ? target.style.removeProperty('height') : null;
		let height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = showmore ? `${showmore}px` : `0px`;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		target.offsetHeight;
		target.style.transitionProperty = "height, margin, padding";
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		window.setTimeout(() => {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			target.classList.remove('_slide');
			// Створюємо подію
			document.dispatchEvent(new CustomEvent("slideDownDone", {
				detail: {
					target: target
				}
			}));
		}, duration);
	}
}
let _slideToggle = (target, duration = 500, widget=false) => {
	if (target.hidden) {
		return _slideDown(target, duration);
	} else {
		return _slideUp(target, duration, 0, widget);
	}
}

const widgets = document.querySelectorAll(".selling-widget-wrapper");
const prices = document.querySelectorAll(".variants-selector__prices");
const purchaseInputs = document.querySelectorAll("input[name='purchase']");
purchaseInputs.forEach((purchaseInput)=>{
  purchaseInput.addEventListener("change", function(e){   
    const currentValue = purchaseInput.value;
	const featuredImage = purchaseInput.dataset.image;

        widgets.forEach((widget)=>{
          if(currentValue!=widget.getAttribute("data-purchase")){
           !widget.classList.contains("widget-hide") ? widget.classList.add("widget-hide") : null;
           widget.classList.contains("widget-active") ? widget.classList.remove("widget-active") : null;
          } else{
              widget.classList.contains("widget-hide") ? widget.classList.remove("widget-hide") : null;
            !widget.classList.contains("widget-active") ? widget.classList.add("widget-active") : null;
            const activeRadio = document.querySelector(".widget-active .selling-widget__plan input[type='radio']:checked");         
          }
        })
	if(featuredImage){
		const sliderThumb = purchaseInput.closest("section").querySelector(`.gem-slider-item[media-poster='${featuredImage}']`);
		sliderThumb.click();
	}
  })
})

async function addAllToCart(button){
  button.classList.add("loading");
  const formData = [];
  const variantId = document.querySelector(".selling-widget-wrapper.widget-active input.selling-widget__variant-id").value;
  const quantity = 1;

  
  const gifts = document.querySelectorAll(".selling-widget-wrapper.widget-active .offer-widget__gift[data-id]");
  if(gifts && gifts.length > 0){
    gifts.forEach((gift)=>{
      formData.push({ id: gift.dataset.id, quantity: 1 });
    })
  }
  const upsells = document.querySelectorAll(".selling-widget-wrapper.widget-active .hh-upsell-btn");
  if(upsells && upsells.length > 0){
    upsells.forEach((upsell)=>{
      formData.push({ id: upsell.dataset.variantId, quantity: 1 });
    })
  }
  formData.push(
    { id: variantId, 
      quantity: parseInt(quantity), 
      
    }
  );
 
  await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: formData }),
  })
  .then(response => response.json())
  .then(data => {
  
    window.SLIDECART_UPDATE(function(){
      button.classList.remove("loading");
      window.SLIDECART_OPEN();
    });
    

    
  })
  .catch(error => {
      console.error('Error adding to cart:', error);
  });

}
const buyButtons = document.querySelectorAll(".selling-widget__button");
 buyButtons.forEach((buyButton)=>{
       buyButton.addEventListener("click", function(e){
       addAllToCart(buyButton)
    
  })  
})